interface IEnvironment {
  apiUrl: string;

  fullStory: {
    orgId: string;
  };

  name: string;

  // Running from source code
  isLocal: boolean;

  // Build types
  isDev: boolean;
  isStaging: boolean;
  isProd: boolean;

  browser: {
    isMobile: boolean;
    isFirefox: boolean;
  };
}

export const environment: IEnvironment = {
  apiUrl: import.meta.env.VITE_API_URL || '',

  fullStory: {
    orgId: import.meta.env.VITE_FULLSTORY_ORG_ID || '',
  },

  name: import.meta.env.VITE_ENV_NAME || 'unknown',

  isLocal: import.meta.env.DEV,

  isDev: import.meta.env.VITE_ENV_NAME === 'dev',
  isStaging: import.meta.env.VITE_ENV_NAME === 'staging',
  isProd: import.meta.env.VITE_ENV_NAME === 'prod',

  browser: {
    // Taken from here https://stackoverflow.com/questions/77506413/detecting-if-the-user-is-on-desktop-or-mobile-in-the-browser
    isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
    isFirefox: navigator.userAgent.includes('Firefox/'),
  },
};
